export type VantageVisualizationType = 'table' | 'bar' | 'line' | 'pie' | 'json';

export type VantageExportFormat = 'csv' | 'json' | 'xlsx';

export type VantageDisplayMode = 'code' | 'codeAndVisualization' | 'visualization';

export type VantageResultDensity = 'comfortable' | 'compact';

export type VantageEditorPreferences = {
    autocomplete: boolean;
    formatSqlOnRun: boolean;
    resultDensity: VantageResultDensity;
    validateOnChange: boolean;
};

export type VantageColumnMetadata = {
    name: string;
    type: string;
    nullable?: boolean;
};

export type VantageQueryResult = {
    columns: VantageColumnMetadata[];
    rows: Record<string, unknown>[];
    rowCount: number;
    runtimeMs: number;
};

export type VantageDataBlock = {
    id: string;
    referenceName: string;
    sql: string;
    visualization: VantageVisualizationType;
    displayMode: VantageDisplayMode;
    limit: number;
    columns: VantageColumnMetadata[];
    rowCount: number;
    runtimeMs: number;
    result?: VantageQueryResult;
    createdAt: string;
    updatedAt: string;
};

export type VantageTableMetadata = {
    schema: string;
    name: string;
    columns: VantageColumnMetadata[];
};

export type VantageDynamicVariable = {
    key: string;
    label: string;
    type: 'string' | 'number' | 'boolean' | 'date' | 'null' | 'object' | 'array';
    value?: string | number | boolean | Record<string, unknown> | unknown[] | null;
};

export type VantageMetadata = {
    tables: VantageTableMetadata[];
    variables: VantageDynamicVariable[];
};

export type VantageValidationResult = {
    executable: boolean;
    message?: string;
    compiledSql?: string;
    parameterCount?: number;
};

export type VantageQueryHistoryEntry = {
    id: string;
    dataBlockId?: string;
    referenceName?: string;
    sql: string;
    visualization: VantageVisualizationType;
    displayMode: VantageDisplayMode;
    limit: number;
    rowCount: number;
    runtimeMs: number;
    ranAt: string;
};

export const DEFAULT_VANTAGE_SQL = '';

export const VANTAGE_SQL_PLACEHOLDER = 'SELECT * FROM dashboard LIMIT 25;...';

export const DEFAULT_VANTAGE_LIMIT = 500;
export const MAX_VIEWABLE_VANTAGE_ROWS = 1_000;

export const DEFAULT_VANTAGE_EDITOR_PREFERENCES: VantageEditorPreferences = {
    autocomplete: true,
    formatSqlOnRun: true,
    resultDensity: 'comfortable',
    validateOnChange: true,
};

export type VantageConfig = {
    sql?: string;
    visualization?: VantageVisualizationType;
    displayMode?: VantageDisplayMode;
    limit?: number;
    preferences?: Partial<VantageEditorPreferences>;
    dataBlocks?: VantageDataBlock[];
};
